import React, {Fragment, useEffect, useState} from 'react';
import RestClient from "../../RestAPI/RestClient";
import AppUrl from "../../RestAPI/AppUrl";
import cogoToast from "cogo-toast";
import {Button, Col, Modal, Row} from "react-bootstrap";
import {useSelector} from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import LoadingText from "../Loading/LoadingText";

const GoogleMap = () => {
    let state=useSelector((state)=> state);
    const[DataStatus, setDataStatus]=useState(false);
    const [DataLength, setDatalength]=useState(0)
    const [markers, setMarkers] = useState([]);
    const [DivisionMap, setDivisionMap]=useState([]);
    const [CircleMap, setCircleMap]=useState([]);
    const [MapBin, setMapBin]=useState([]);
    const [BinNameOnMap, setBinNameOnMap]=useState();
    const [DataRevenueOnMap, setDataRevenueOnMap]=useState([]);
    const [ColumnRevenueOnMap, setColumnRevenueOnMap]=useState([{}]);

    const [ShowRevenueOnMap, setShowRevenueOnMap] = useState(false);
    const handleCloseRevenueMapHistory = () => setShowRevenueOnMap(false);
    const handleShowRevenueMapHistory = () => setShowRevenueOnMap(true);

    useEffect(() => {
        const loadMap = () => {
            const map = new window.google.maps.Map(document.getElementById('map'), {
                center: { lat: 23.845899, lng: 90.257224 },
                zoom: 12,
            });

            // ✅ Add markers to map
            markers.forEach((markerData) => {
                const marker = new window.google.maps.Marker({
                    position: {
                        lat: parseFloat(markerData.Lat),
                        lng: parseFloat(markerData.Lng),
                    },
                    map,
                    title: markerData.Name,
                });

                marker.addListener('click', () => {
                    setBinNameOnMap(markerData.Name);
                    setMapBin(markerData.BIN);
                    getRevenueHistoryOnMap(markerData.BIN,0);
                });
            });
        };

        if (markers.length > 0) {
            if (!window.google) {
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDZeBZiyhjxAw2pNjRE0Rqah4NXO0uCsJs`;
                script.async = true;
                script.onload = loadMap;
                document.head.appendChild(script);
            } else {
                loadMap();
            }
        }
    }, [markers]);

    const flagMap=()=>{


        RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set Flag=1 where Bin='"+MapBin+"' "}).then(result => {
            if (result == 1) {
                cogoToast.success("Flag saved")

            } else {
                cogoToast.error("Flag not saved")
            }
        }).catch(error => {
            cogoToast.error(error)
        });


    }
    const getRevenueHistoryOnMap=(BIN,status)=>{

        let jsonObject="";
        if(status==0){
            jsonObject={"sql":" SELECT July_24,July_25,August_24,August_25,September_24,September_25,October_24,October_25,November_24,November_25,December_24,December_25,January_25,January_26,February_25,February_26,March_25,March_26,April_25,April_26,May_25,May_26,June_25,June_26" +
                    ",(July_24+August_24+September_24+October_24+November_24+December_24+January_25+February_25+March_25+April_25+May_25+June_25)As Total_Last_Year," +
                    "(July_25+August_25+September_25+October_25+November_25+December_25+January_26+February_26+March_26+April_26+May_26+June_26)As Total_Upto FROM nbr.revenue_25_26_view where BIN='"+BIN+"' "};

        }
        else if(status==1){jsonObject={"sql":" select FY,Month,round(Closing_balance_vat/Deposited_vat,1)AS Balance_TR,round(Total_Payable_VAT/Deposited_vat,1)AS Payable_TR,`Deposite_%`,`Rebate_%`,`Decreasing_%`,Total_Sales_Value,Total_Payable_Vat,Total_Payable_SD,Total_Input_Tax_Credit_Value,Total_Input_Tax_Credit_VAT,Increasing_Adjustment,Decreasing_Adjustment,Net_Payable_VAT,Net_Payable_SD,Deposited_VAT,Deposited_SD,Closing_Balance_VAT,Closing_Balance_SD,VDS_Increasing,VDS_Decreasing,AT_Paid from Revenue_Analyse_View where BIN='"+BIN+"' order by Month_Code Desc "};}
        else if(status==3){jsonObject={"sql":" select * from debt_report where BIN='"+BIN+"' "};}
        else if(status==4){jsonObject={"sql":" select * from visit_bin where BIN='"+BIN+"' "};}
        else if(status==5){jsonObject={"sql":" select * from BIN where BIN='"+BIN+"' "};}
        else if(status==6){
            jsonObject={"sql":" SELECT HSCODE,Description As Description_Of_Goods,Supply_Qty,Supply_Unit As Unit,Rm_Price,Addition_Price,Addition_Parcentage AS 'Add_%',Total_Price,Entry_Date As 'Effect_Date',DATEDIFF(CURDATE(),Entry_Date) AS Total_Days,Entry_Date,Status,Sale_Category,Comments As Comments_for_goods FROM `Co_Efficient` where BIN='"+BIN+"' "};

        }else if(status==7){
            jsonObject={"sql":" SELECT Court,Mamla_No,Mamla_Year,Mamla_Type,Amount,Status from Mamla where BIN='"+BIN+"' "};

        }else if(status==8){ jsonObject={"sql":" SELECT Id, Reasons from negative_bin where BIN='"+BIN+"' "}
        }else if(status==9){ jsonObject={"sql":" SELECT Bill_year,Bill_Month,Consumption_Unit,Unit_Price AS price,Entry_Officer,Entry_Date from Electricity_Data where BIN='"+BIN+"' "}
        }else if(status==10){ jsonObject={"sql":" SELECT Caller,Call_Date,Comments from Call_Data where BIN='"+BIN+"' "}
        }else if(status==11){ jsonObject={"sql":" SELECT SMS_Date,SMS_Sender,SMS from SMS_Data where BIN='"+BIN+"' "}
        }


        setColumnRevenueOnMap([{}]);setDataRevenueOnMap([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                await setColumnRevenueOnMap(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataRevenueOnMap(result);

                handleShowRevenueMapHistory();

            }
        }).catch(error=>{ });

    }
    const getMapBIN=()=>{
        setDataStatus(true);
        setDatalength(0)
        const Category=document.getElementById("cmbMapCategory");
        const CategoryValue=Category.options[Category.selectedIndex].text;

        const Commi=document.getElementById("cmbCommiMap");
        const CommiValue=Commi.options[Commi.selectedIndex].text;

        const Division=document.getElementById("cmbDivisionMap");
        const DivisionValue=Division.options[Division.selectedIndex].text;


        const Circle=document.getElementById("cmbCircleMap");
        const CircleValue=Circle.options[Circle.selectedIndex].text;

        const Range=document.getElementById("cmbMapRange");
        const RangeValue=Range.options[Range.selectedIndex].text;

        const Items=document.getElementById("cmbMapItems");
        const ItemsValue=Items.options[Items.selectedIndex].text;
        const SmArea=document.getElementById("txtSmArea").value;

        const BinIvasStatus=document.getElementById("cmbBinIvasStatus");
        const BinIvasStatusValue=BinIvasStatus.options[BinIvasStatus.selectedIndex].text;


        const BondMap=document.getElementById("cmbBondMap");
        const FlagMap=document.getElementById("cmbFlagMap");
        const DataLimit=document.getElementById("cmbDataLimitMap");
        const DataLimitValue=DataLimit.options[DataLimit.selectedIndex].text;
        const SearchBin=document.getElementById("txtSearchMapBin").value;
        const SearchName=document.getElementById("txtSearchMapName").value;
        const SearchMobile=document.getElementById("txtSearchMapMobile").value;


        let getCommi=" ";
        let getDivision=" ";
        let getCircle=" ";
        let getCategory=" ";
        let getItems="";
        let getFloorSpace;
        let getlimit ;
        let getBinStatus="" ;
        let getBin="";
        let getName="";
        let getMobile="";
        let getSmArea=""
        let jsonObject;
        let getRange="";
        let getBondMap="";
        let getFlagMap="";

        if(state.accessCom=="NBR")
        {if(Commi.selectedIndex!=0){getCommi="And Commissionerate Like '%"+CommiValue+"%'"}}
        else{getCommi="And Commissionerate Like '%"+state.accessCom+"%'"}
        if(state.accessDiv=="All Division"){if(Division.selectedIndex!=0){getDivision="And Division Like '%"+DivisionValue+"%'"}}
        else{getDivision="And Division Like '%"+state.accessDiv+"%'"}
        if(state.accessCir=="All Circle"){if(Circle.selectedIndex!=0){getCircle="And Circle Like '%"+CircleValue+"%'"}}
        else {getCircle="And Circle Like '%"+state.accessCir+"%'"}

        if(Range.selectedIndex!=0){getRange="And Range_Name ='"+RangeValue+"'"}
        if(BinIvasStatus.selectedIndex !=0){getBinStatus=" And BIN_Status ='"+BinIvasStatusValue+"' " }


        if(Category.selectedIndex!=0){getCategory="And Economic_Activity Like '%"+CategoryValue+"%'  "}
        if(SmArea!=""){getCategory="And Economic_Activity Like '%"+SmArea+"%'  "}
        if(Items.selectedIndex!=0){getItems="And Category= '"+ItemsValue+"'"}

        if(SearchBin!=""){ getBin=" And BIN Like '%"+SearchBin+"%'"}
        if(SearchName!=""){ getName=" And Name Like '%"+SearchName+"%'"}
        if(SearchMobile!=""){ getMobile=" And Mobile Like '%"+SearchMobile+"%'"}

        if(BondMap.selectedIndex ==1){ getBondMap=" And Bond_Licence =1 "}
        if(BondMap.selectedIndex ==2){ getBondMap=" And Bond_Licence =0 "}

        if(FlagMap.selectedIndex ==1){ getFlagMap=" And Flag >0 "}
        if(FlagMap.selectedIndex ==2){ getFlagMap=" And Flag =0 "}
        if(FlagMap.selectedIndex ==3){getFlagMap="And Flag =2"}
        if(FlagMap.selectedIndex ==4){getFlagMap="And Flag =3"}
        if(FlagMap.selectedIndex ==5){getFlagMap="And Flag =4"}


        if(DataLimit.selectedIndex!=0){getlimit=" LIMIT " +DataLimitValue
            jsonObject={"sql":" Select Name,BIN,Lat,Lang as Lng from BIN where Lat >0 "+getDivision+" "+getCircle+" "+getRange+" "+getCategory+" "+getItems+" "+getName+" "+getBin+" "+getBondMap+" "+getFlagMap+" "+getlimit+"  "}

        }else{getlimit=""
            jsonObject={"sql":" Select count(BIN)AS 'Total BIN' from Bin where Lat >0 "+getCommi+" "+getDivision+" "+getCircle+" "+getCategory+" "+getItems+"  "+getBin+" "+getName+" "+getSmArea+" "+getMobile+" "+getRange+" "+getBinStatus+" "+getBondMap+" "+getFlagMap+" "+getlimit+" "}

        }


        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{
            setDatalength(result.length)
            if(result==""){cogoToast.error("Data not found");setDataStatus(false)}else {

                await setMarkers(result);
                setDataStatus(false);
            }
        }).catch(error=>{ setDataStatus(false);});
    }

    return (
        <Fragment>



            <div >
                <Row className="mt-2">

                    <Col lg={3}>
                        <div className="">
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">NBR</label></Col>
                                <Col lg={9}  xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbCommiMap"
                                            onChange={()=>{
                                                setDivisionMap([]);
                                                setCircleMap([]);
                                                const e = document.getElementById("cmbCommiMap");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.division.filter(x => x.Commissionerate_Id==value);
                                                setDivisionMap(dt)


                                            }}
                                    >
                                        <option >NBR</option>
                                        {
                                            state.commi.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Division</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbDivisionMap"
                                            onChange={()=>{
                                                setCircleMap([])
                                                const e = document.getElementById("cmbDivisionMap");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.circle.filter(x => x.Division_Id==value);
                                                setCircleMap(dt)


                                            }}
                                    >
                                        <option >All Division</option>

                                        {
                                            DivisionMap.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Circle</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbCircleMap" >
                                        <option >All Circle</option>

                                        {
                                            CircleMap.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }


                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Range</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbMapRange"  >
                                        <option >All Range</option>
                                        <option >Range-1</option>
                                        <option >Range-2</option>
                                        <option >Range-3</option>
                                        <option >Range-4</option>
                                        <option >Range-5</option>
                                        <option >Range-6</option>
                                        <option >Range-7</option>
                                        <option >No Range</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Category</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbMapCategory"  >
                                        <option >All Category</option>
                                        <option >Manufacturing</option>
                                        <option >Services</option>
                                        <option >Other</option>
                                        <option >Imports</option>
                                        <option >Exports</option>
                                        <option >Construction</option>
                                        <option >Wholesale</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">S/M Area</label></Col>
                                <Col lg={9} xs={8}>
                                    <input type="text" className="w-100" id="txtSmArea"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Items</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbMapItems"  >
                                        <option value="0">All Items</option>
                                        {
                                            state.category.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }

                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Status</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbBinIvasStatus"  >
                                        <option >All</option>
                                        <option >Active</option>
                                        <option >Cancelled</option>
                                        <option >Suspended</option>
                                        <option >Locked</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">BIN</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtSearchMapBin"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Name</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtSearchMapName"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Mobile</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtSearchMapMobile"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">BOND</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbBondMap"  >
                                        <option >Both</option>
                                        <option >Yes</option>
                                        <option >No</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Flag</label></Col>
                                <Col lg={9}xs={8}>
                                    <select   className="float-start w-100 customfontsize" id="cmbFlagMap"  >
                                        <option >All</option>
                                        <option >Yes</option>
                                        <option >No</option>
                                        <option>High</option>
                                        <option>Medium</option>
                                        <option>Highest</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Data</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbDataLimitMap"  >
                                        <option >All</option>
                                        <option >10</option>
                                        <option >20</option>
                                        <option >50</option>
                                        <option >100</option>
                                        <option >200</option>
                                        <option >500</option>
                                        <option >1000</option>
                                        <option >2000</option>
                                        <option >3000</option>
                                        <option >5000</option>
                                        <option >10000</option>
                                        <option >20000</option>
                                        <option >50000</option>


                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-4">
                                <Col lg={3} >

                                </Col>
                                <Col lg={9} >
                                    <button className="w-100 text-danger" onClick={getMapBIN}>Search</button>
                                </Col>


                            </Row >
                            <Row className="mt-4">
                                <label className="text-danger">Data found: {DataLength}</label>
                            </Row>


                        </div>
                    </Col>

                    <Col lg={9}>

                        {
                            DataStatus? <LoadingText/>
                                : <div id="map" style={{ width: '100%', height: '700px' }} />


                        }


                    </Col>

                </Row>
            </div>
            <Modal show={ShowRevenueOnMap} onHide={handleCloseRevenueMapHistory} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>

                    <label>{BinNameOnMap}</label>
                    <hr/>
                    <label className="text-danger">:-BIN:- {MapBin}</label>

                </Modal.Header>
                <Modal.Body className="scrollable-x">
                    <div className="wide-content">
                        {<BootstrapTable  keyField='Id'  data={DataRevenueOnMap} columns={ColumnRevenueOnMap}></BootstrapTable>}
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleCloseRevenueMapHistory}>Close</Button>
                    <Button variant="secondary" onClick={()=>getRevenueHistoryOnMap(MapBin,0)}>Total</Button>
                    <Button variant="primary" onClick={()=>getRevenueHistoryOnMap(MapBin,1)}>Analysis</Button>
                    <Button variant="secondary" onClick={()=>getRevenueHistoryOnMap(MapBin,3)}>Debt</Button>
                    <Button variant="secondary" onClick={()=>getRevenueHistoryOnMap(MapBin,4)}>Visit</Button>
                    <Button variant="danger" onClick={()=>getRevenueHistoryOnMap(MapBin,5)}>Basic Info</Button>
                    <Button variant="primary" onClick={()=>getRevenueHistoryOnMap(MapBin,6)}>4.3</Button>
                    <Button variant="primary" onClick={()=>getRevenueHistoryOnMap(MapBin,7)}>Mamla</Button>
                    <Button variant="primary" onClick={()=>getRevenueHistoryOnMap(MapBin,8)}>Negative revenue</Button>
                    <Button variant="primary" onClick={()=>getRevenueHistoryOnMap(MapBin,9)}>Electricity Bill</Button>
                    <Button variant="primary" onClick={()=>getRevenueHistoryOnMap(MapBin,10)}>Call Log</Button>
                    <Button variant="primary" onClick={()=>getRevenueHistoryOnMap(MapBin,11)}>SMS Log</Button>
                    <Button variant="danger" onClick={flagMap}>Make Flag</Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    )


};

export default GoogleMap;
